import translations from 'ember-intl/translations';
import Ember from 'ember';

/**
 * @private
 * @hide
 */
export default function hydrate(service) {
  translations.forEach(([locale, translations]) => {
    service.addTranslations(locale, translations);
  });
  if (!Ember.testing) {
    translations.forEach(([locale, translations]) => {
      service.addTranslations(locale, translations);
    });
  }
}